import { Button } from "@nextui-org/button";
import { Tooltip } from "@nextui-org/tooltip";
import { Move, Pencil, ZoomIn, ZoomOut } from "lucide-react";
import { useTranslations } from 'next-intl';
import React from 'react';

interface ImageControlsProps {
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  toggleMode: () => void;
  mode: 'draw' | 'pan';
  handleClearCanvas: () => void;
  isImageLoaded: boolean;
}

export const ImageControls: React.FC<ImageControlsProps> =  ({
  handleZoomIn,
  handleZoomOut,
  toggleMode,
  mode,
  handleClearCanvas,
  isImageLoaded
}) => {
  const t = useTranslations('ImageControls')
  return (
    <div className="flex space-x-2">
      <Tooltip content={mode === 'draw' ? t('switchToPanMode') : t('switchToDrawMode')}>
        <Button
          isIconOnly
          onClick={toggleMode}
          disabled={!isImageLoaded}
          aria-label={t('toggleMode')}
          color={mode === 'draw' ? "default" : "primary"}
        >
          {mode === 'draw' ? <Move /> : <Pencil />}
        </Button>
      </Tooltip>
      <Tooltip content={t('zoomIn')}>
        <Button
          isIconOnly
          onClick={handleZoomIn}
          disabled={!isImageLoaded}
          aria-label={t('zoomIn')}
        >
          <ZoomIn />
        </Button>
      </Tooltip>
      <Tooltip content={t('zoomOut')}>
        <Button
          isIconOnly
          onClick={handleZoomOut}
          disabled={!isImageLoaded}
          aria-label={t('zoomOut')}
        >
          <ZoomOut />
        </Button>
      </Tooltip>
      <Tooltip content={t('clearCanvas')}>
        <Button
          isIconOnly
          onClick={handleClearCanvas}
          disabled={!isImageLoaded}
          aria-label={t('clearCanvas')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path></svg>
        </Button>
      </Tooltip>
    </div>
  );
};